<template>
  <div class="el-col-24">
    <h5 class="warp-title">客服工单详情</h5>
    <el-descriptions :column="1" border labelClassName="label-box">
      <el-descriptions-item label="工单ID">{{ulData.id}}</el-descriptions-item>
      <el-descriptions-item label="用户ID">{{ulData.imUserId}}</el-descriptions-item>
      <el-descriptions-item label="组别">{{ ulData.groupName }}</el-descriptions-item>
      <el-descriptions-item label="联系方式">
        <div class="flex-common-style" v-if="ulData.encryptionPhone">
          {{ ulData.encryptionPhone }}
          <p class="cursor blue ml10" @click="seePhone(ulData.platformPhone)" v-if="phoneViewStatus === 0">查看</p>
        </div>
        <div v-else class="gray">暂无</div>
      </el-descriptions-item>
      <el-descriptions-item label="用户信息备注">{{ ulData.userRemark }}</el-descriptions-item>
      <el-descriptions-item label="平台">{{ ulData.platformTypeName }}</el-descriptions-item>
      <el-descriptions-item label="平台终端类型">{{ ulData.platformTerminalTypeName }}</el-descriptions-item>
      <el-descriptions-item label="创建人">{{ ulData.createUserName }}</el-descriptions-item>
      <el-descriptions-item label="当前跟进人">{{ ulData.updateUserName }}</el-descriptions-item>
      <el-descriptions-item label="用户类型">{{ ulData.platformUserTypeName }}</el-descriptions-item>
      <el-descriptions-item label="受理方式">{{ ulData.acceptanceMethodName }}</el-descriptions-item>
      <el-descriptions-item label="问题进展">{{ ulData.problemProgress }}</el-descriptions-item>
      <el-descriptions-item label="提单时间">{{ ulData.createTime }}</el-descriptions-item>
      <el-descriptions-item label="问题一级分类">{{ ulData.problemOneTypeName }}</el-descriptions-item>
      <el-descriptions-item label="问题二级分类">{{ ulData.problemTwoTypeName }}</el-descriptions-item>
      <el-descriptions-item label="设备信息/课堂信息">{{ ulData.equipmentClassInfo }}</el-descriptions-item>
      <el-descriptions-item label="工单聊天内容">
        <div class="flex-common-style">
          <el-link type="primary" v-if="workContent" @click="openChatData">查看<span v-if="ulData.orderType === 2">(Ai自动提交)</span></el-link>
          <p class="gray" v-else>暂无</p>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="问题描述">
        <div class="flex-common-style">
          <el-link type="primary" @click="openDetail" v-if="ulData.problemDescription">查看</el-link>
          <p class="gray" v-else>暂无</p>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <div class="line"></div>
    <h4>历史记录</h4>
    <ul class="history">
      <li v-for="(item, index) in historyUl" :key="index">
        <div class="title">{{item.optInfo}}</div>
        <div class="gray" v-html="item.remark">
        </div>
      </li>
    </ul>
    <div class="fixed-tab" :class="this.$store.state.Auth.collapse? 'fixed-tab-close': 'fixed-tab-open'">
      状态：{{ulData.handerStatus}} <el-button @click="change()" v-if="querybtn.customerworkorder_status_change === 1">状态变更</el-button>
      <el-button type="primary" class="fr" @click="follow()" v-if="querybtn.customerworkorder_follow === 1">跟进</el-button>
      <el-button class="fr" @click="assign()" v-if="querybtn.customerworkorder_assign === 1">指派</el-button>
    </div>
    <el-dialog
      :title="tit"
      :show-close="false"
      class="dialogs"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      @close="handleAssignClose">
      <el-form :model="assignForm" size="small" label-position="top" :rules="assignRule" ref="assignForm">
        <el-form-item label="跟进人" prop="customerId" v-if="open === 1">
          <el-select v-model="assignForm.customerId" placeholder="选择跟进人">
            <el-option v-for="(item, index) in customerOption" :key="index" :label="item.nickName" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status" v-if="open === 2">
          <el-select v-model="assignForm.status" placeholder="状态">
            <el-option v-for="(item, index) in statusOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="content">
          <myQuill :content.sync="assignForm.content" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="assignForms('assignForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="问题描述"
      :show-close="true"
      class="dialogs"
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="860px">
      <div class="con-data" v-html="ulData.problemDescription" v-imgViewer>
      </div>
    </el-dialog>
    <OrderChatRecordDrawer :isShow.sync="isChatRecordShow" :orderType="ulData.orderType" :workContent="workContent" />
  </div>
</template>

<script>
import OrderChatRecordDrawer from '../Public/OrderChatRecordDrawer.vue'
import {queryCustomerWorkOrderDetail, queryCustomerHistoryRecordList, queryBusinessTypeList, queryJurisdictionCustomerList, customerWorkOrderAssign, customerWorkOrderChangeStatus, customerWorkOrderFollowUp} from '../../api/order/index'
import { queryButtonPermission } from '../../api/public/auth'
export default {
  name: 'OrderTalkDetail',
  components: {
    OrderChatRecordDrawer
  },
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
    if (location.href.indexOf('?') > -1) {
      this.activeName = 'second'
      this.baseUrl = location.href.split('?')[0]
    } else {
      this.baseUrl = location.href
    }
  },
  data () {
    return {
      phoneViewStatus: global.$siderItem.phoneViewStatus,
      isChatRecordShow: false,
      workContent: this.$route.query.workContent,
      querybtn: {},
      id: this.$route.params.id,
      ulData: {},
      historyUl: [],
      dialogVisible: false,
      dialogVisible1: false,
      statusOption: [],
      customerOption: [],
      open: '',
      assignForm: {
        customerId: '',
        content: '',
        status: ''
      },
      assignRule: {
        customerId: [
          { required: true, message: '请选择跟进人', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      tit: ''
    }
  },
  methods: {
    // 查看手机号
    seePhone (phone) {
      this.$alert(phone, '提示', {showConfirmButton: false})
    },
    openChatData () {
      this.isChatRecordShow = true
    },
    initData () {
      let data = {
        workOrderId: this.id,
        phoneViewStatus: this.phoneViewStatus
      }
      queryCustomerWorkOrderDetail(data).then(info => {
        let data = info.data.resultData
        if (info.data.resultCode === 0) {
          this.ulData = data
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
      let datas = {
        workOrderType: 1,
        workOrderId: this.id
      }
      queryCustomerHistoryRecordList(datas).then(info => {
        let data = info.data.resultData
        if (info.data.resultCode === 0) {
          this.historyUl = data
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    },
    openDetail () {
      this.dialogVisible1 = true
    },
    assign () {
      this.open = 1
      this.tit = '指派'
      this.assignForm.customerId = ''
      this.dialogVisible = true
    },
    change () {
      this.open = 2
      this.tit = '状态变更'
      this.assignForm.status = ''
      this.dialogVisible = true
    },
    follow () {
      this.open = 3
      this.tit = '跟进'
      this.dialogVisible = true
    },
    handleAssignClose () {
      this.$refs.assignForm.resetFields()
    },
    assignForms (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.assignForm.content.length > 10000) {
            this.$message.error('备注内容不能超过1000字')
            return false
          }
          if (this.open === 1) {
            let data = {
              customerId: this.assignForm.customerId,
              workOrderId: this.id,
              remark: this.assignForm.content
            }
            customerWorkOrderAssign(data).then(info => {
              if (info.data.resultCode === 0) {
                this.dialogVisible = false
                this.initData()
              } else {
                this.$message.error(info.data.resultMessage)
              }
            })
          } else if (this.open === 2) {
            let data = {
              status: this.assignForm.status,
              workOrderId: this.id,
              remark: this.assignForm.content
            }
            customerWorkOrderChangeStatus(data).then(info => {
              if (info.data.resultCode === 0) {
                this.dialogVisible = false
                this.initData()
              } else {
                this.$message.error(info.data.resultMessage)
              }
            })
          } else if (this.open === 3) {
            let data = {
              workOrderId: this.id,
              remark: this.assignForm.content
            }
            customerWorkOrderFollowUp(data).then(info => {
              if (info.data.resultCode === 0) {
                this.dialogVisible = false
                this.initData()
              } else {
                this.$message.error(info.data.resultMessage)
              }
            })
          }
        } else {
          return false
        }
      })
    }
  },
  mounted () {
    this.initData()
    let data1 = {
      typeCode: 'im_customer_hander_status'
    }
    queryBusinessTypeList(data1).then(info => {
      if (info.data.resultCode === 0) {
        this.statusOption = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
    queryJurisdictionCustomerList().then(info => {
      if (info.data.resultCode === 0) {
        this.customerOption = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  }
}
</script>
<style lang="less" scoped>
/deep/.label-box{
  width: 180px;
}
.el-col-24{
  padding-bottom: 60px;
}
.el-button+.el-button{
  margin-left: 0;
}
.el-button--small{
  padding: 9px 10px;
}
.search .el-input.w100{
  width: 100px;
}
.uploadImg{
  margin-top: 10px;
}
.revise{
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
}
.el-table{
  width: 600px;
  tr td:first-child{
    width: 200px;
  }
}
.line{
  border-top: 1px solid #EBEEF5;
  margin: 30px 0 20px;
  width: 100%;
}
h4{
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.history{
  .title{
    font-size: 16px;
    margin-bottom: 10px;
  }
  .gray{
    margin-bottom: 10px;
    font-size: 14px;
  }
}
.fixed-tab{
  position: fixed;
  bottom: 0;
  right: 20px;
  transition: all 0.5s;
  background: #EBEEF5;
  padding: 10px 20px;
  font-size: 14px;
  .el-button{
    margin-left: 10px;
  }
}
.fixed-tab-open{
  left: 210px;
}
.fixed-tab-close{
  left: 65px;
}
/deep/.con-data{
  max-height: 500px;
  overflow-y: auto;
  img{
    max-width: 100%;
  }
}
.chat-data-drawer{
  /deep/.el-drawer{
    width: 50%!important;
  }
  /deep/section.el-drawer__body{
    overflow-y: auto;
    padding: 20px;
  }
  .drawer-footer{
    text-align: right;
  }
  /deep/.chat-message-container{
    max-height: fit-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/TalkDetail.vue